import { createContext, useContext, useRef, useState } from "react";

const InterviewContext = createContext();

const InterviewContextProvider = ({ children }) => {
  const [interviewOpen, setInterviewOpen] = useState(false);
  const [questionNaviagte, setQuestionNavigate] = useState(false);
  const [speechtext, setSpeechText] = useState("");
  const [thankyouPage,setThankyouPage]=useState(false);

  const [warningCount, setWarningCount] = useState(0);
  const [showWarningModal, setShowWarningModal] = useState(false);

  const [generatedQuestion, setGeneratedQuestion] = useState([]);
  const [user, setUser] = useState(null);

  const [userName, setUserName] = useState("User");
  const [result, setResult] = useState([]);

  //for side bar code language selection and code
  const [submitedCode, setSubmitedCode] = useState(null);
  const [language, setLanguage] = useState("cpp");

  const faceWarningTriggeredRef = useRef(false); // 🔐 Prevent multiple triggers


  const [role, setRole] = useState("");
  const [roleId, setRoleId] = useState(null); // New state for roleId
  const [adminId, setAdminId] = useState(null); // New state for adminId
  const [resumeAvailable, setResumeAvailable] = useState(true); // New state for resume availability (default true until verified)
  const [aiMode, setAiMode] = useState(false);
  const [warningReason, setWarningReason] = useState(null);
  const [warningLogs, setWarningLogs] = useState([]);
    const [resumeData, setResumeData] = useState(null);   // for tracking existing resume
    const [capturedPhoto, setCapturedPhoto] = useState(null);

  // TESTING STATE FOR DIRECT AVATAR
  // const [generatedQuestion, setGeneratedQuestion] = useState([
  //   {
  //     question:"What is overfitting, and how can you prevent it ?",
  //     timing:180
  //   },
  //   {question:"What is the difference between L1 and L2 regularization ?",
  //     timing:180
  //   },
  //   {question:"How does gradient descent work?",
  //     timing:180
  //   },
  //   {question:"What is Machine Learning ?",
  //     timing:180
  //   },
  //   {question:"What are hyperparameters, and how do you tune them ?",
  //     timing:180
  //   },
  //   {
  //     question:"What is overfitting, and how can you prevent it ?",
  //     timing:180
  //   },
  //   {
  //     question:"What is overfitting, and how can you prevent it ?",
  //     timing:180
  //   },
  //   {
  //     question:"What is overfitting, and how can you prevent it ?",
  //     timing:180
  //   },
  //   {
  //     question:"What is overfitting, and how can you prevent it ?",
  //     timing:180
  //   },
  //   {
  //     question:"What is overfitting, and how can you prevent it ?",
  //     timing:180
  //   },

  // ]);
  // const [user, setUser] = useState({_id:1,fullName:"vivek yadav"});

//state for the handle warning


console.log("User",user)

  const enterFullScreen = () => {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    }
    setShowWarningModal(false);
  }; 

  const triggerWarning = (type) => {
  const timestamp = new Date().toISOString();

  setWarningLogs(prev => [
    ...prev,
    {
      type,
      time: timestamp,
      message: getWarningMessage(type),
    }
  ]);

  if (!showWarningModal) {
    setShowWarningModal(true);
    setWarningCount(prev => prev + 1);
    setWarningReason(type);
  }
};

const getWarningMessage = (type) => {
  switch (type) {
    case "fullscreen":
      return "Exited fullscreen or switched tabs.";
    case "no face":
      return "No face detected.";
    case "multiple faces":
      return "Multiple faces detected.";
    default:
      return "Unknown warning.";
  }
};


  const SESSION_STORAGE_KEY = "ezsync_active_interview_session";

  const saveActiveSession = (sessionData) => {
    try {
      const existing = loadActiveSession() || {};
      const updated = { ...existing, ...sessionData, lastUpdated: Date.now() };
      sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(updated));
    } catch (e) {
      console.warn("Failed to save active session to sessionStorage:", e);
    }
  };

  const loadActiveSession = () => {
    try {
      const data = sessionStorage.getItem(SESSION_STORAGE_KEY);
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.warn("Failed to load active session from sessionStorage:", e);
      return null;
    }
  };

  const clearActiveSession = () => {
    try {
      sessionStorage.removeItem(SESSION_STORAGE_KEY);
    } catch (e) {
      console.warn("Failed to clear active session:", e);
    }
  };

  return (
    <InterviewContext.Provider
      value={{
        submitedCode,
        setSubmitedCode,
        language,
        setLanguage,
        interviewOpen,
        setInterviewOpen,
        questionNaviagte,
        setQuestionNavigate,
        speechtext,
        setSpeechText,
        setGeneratedQuestion,
        generatedQuestion,
        user,
        setUser,
        setResult,
        result,
        userName,
        setUserName,
        setThankyouPage,
        thankyouPage,
        role,
        setRole,
        adminId, setAdminId, // Exposed
        resumeAvailable, setResumeAvailable, // Exposed
        aiMode,
        setAiMode,
        capturedPhoto,
        setCapturedPhoto,
        enterFullScreen,
        triggerWarning,
        warningCount,
        showWarningModal,
        setShowWarningModal,
        setWarningCount,
        faceWarningTriggeredRef,
        warningReason,setWarningReason,warningLogs,
        roleId, setRoleId, // Added roleId and setRoleId
        resumeData,
        setResumeData,
        saveActiveSession,
        loadActiveSession,
        clearActiveSession
      }}
    >
      {children}
    </InterviewContext.Provider>
  );
};

// Custom hook to consume the context
const useInterviewStart = () => {
  const context = useContext(InterviewContext);
  if (!context) {
    throw new Error(
      "useInterviewStart must be used within an InterviewContextProvider"
    );
  }
  return context;
};

export { InterviewContextProvider, useInterviewStart };
